
/* injects from baggage-loader */

import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import SmartTable from '../../../../../components/smartTable';
import { goldenRaceCasinoTicketInfoColumnConfig, goldenRaceRacingSelectionColumnConfig, goldenRaceSelectionColumnConfig } from '../tableConfigs';
import { GameGroupTypeEnum } from '../../constants/enums';
import CasinoNumbers from '../../components/casinoNumbers';
import HorseNumbers from '../../components/horseNumbers';

const columnConfigMap = {
    [GameGroupTypeEnum.Generic]: goldenRaceSelectionColumnConfig,
    [GameGroupTypeEnum.Sport]: goldenRaceSelectionColumnConfig,
    [GameGroupTypeEnum.Lottery]: goldenRaceCasinoTicketInfoColumnConfig,
    [GameGroupTypeEnum.Racing]: goldenRaceRacingSelectionColumnConfig,
};


const GoldenRaceSingle = ({ allBets, showFinalOutcome }) => {
    const bet = allBets[0];
    const gameGroupName = bet.event.gameGroupName;
    const finalOutcome = bet.win_event?.finalOutcome;

    const columnConfig = useMemo(() => columnConfigMap[gameGroupName](), [gameGroupName]);

    return <>
        <SmartTable
            data={[bet]}
            columnConfig={columnConfig}
        />

        {showFinalOutcome && finalOutcome && <>
            {gameGroupName === GameGroupTypeEnum.Lottery && <CasinoNumbers numbers={finalOutcome} />}
            {gameGroupName === GameGroupTypeEnum.Racing && <HorseNumbers horses={finalOutcome}/>}
        </>}
    </>;
};

GoldenRaceSingle.propTypes = {
    allBets: PropTypes.array.isRequired,
    showFinalOutcome: PropTypes.bool,
};

GoldenRaceSingle.defaultProps = {
    showFinalOutcome: true,
};

export default GoldenRaceSingle;